import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, vModelSelect as _vModelSelect, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/common/hd_prev_btn.png'
import _imports_1 from '@/assets/user/form_ico1.png'
import _imports_2 from '@/assets/user/form_ico4.png'
import _imports_3 from '@/assets/common/write_ico.png'


const _hoisted_1 = { class: "layer" }
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = { id: "header" }
const _hoisted_4 = { class: "header_wrap" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "logo" }, "META HEALTH", -1)
const _hoisted_8 = { class: "content" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", { class: "page_title" }, "간편 회원가입", -1)
const _hoisted_10 = { id: "user_form" }
const _hoisted_11 = { class: "input_wrap" }
const _hoisted_12 = { class: "input_box input_verf_box" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "ico" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: ""
  })
], -1)
const _hoisted_14 = { class: "email_box" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", null, "@", -1)
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<option value=\"naver.com\">naver.com</option><option value=\"gmail.com\">gmail.com</option><option value=\"hanmail.net\">hanmail.net</option><option value=\"kakao.com\">kakao.com</option><option value=\"직접입력\">직접입력</option>", 5)
const _hoisted_21 = [
  _hoisted_16
]
const _hoisted_22 = { class: "input_box" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", { class: "ico" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  })
], -1)
const _hoisted_24 = { class: "info_input_box" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "input_info" }, "숫자만 입력", -1)
const _hoisted_26 = {
  key: 1,
  class: "verf_txt fail",
  style: {"display":"block"}
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("img", { src: _imports_3 }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", { class: "check_form_info" }, "VAS 설문 진행을 위한 간편 회원가입입니다.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              type: "button",
              class: "menu_btn",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
            }, _hoisted_6),
            _hoisted_7
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("form", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.state.email) = $event)),
                    placeholder: "이메일",
                    onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.emailEdit && $setup.emailEdit(...args)))
                  }, null, 544), [
                    [_vModelText, $setup.state.email]
                  ]),
                  _hoisted_15,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    style: _normalizeStyle(!$setup.state.showDomain ? 'display:block' : 'display:none'),
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.state.directDomain) = $event)),
                    placeholder: "직접입력",
                    class: "direct_email",
                    onInput: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.emailEdit && $setup.emailEdit(...args)))
                  }, null, 36), [
                    [_vModelText, $setup.state.directDomain]
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    style: _normalizeStyle(!$setup.state.showDomain ? 'display:block' : 'display:none'),
                    class: "email_change_btn",
                    onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.emailChangeBtn && $setup.emailChangeBtn(...args)))
                  }, null, 4),
                  ($setup.state.showDomain)
                    ? _withDirectives((_openBlock(), _createElementBlock("select", {
                        key: 0,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.state.domain) = $event)),
                        id: "email_select",
                        onChange: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => ($setup.selectDomain && $setup.selectDomain(...args)))
                      }, _hoisted_21, 544)), [
                        [_vModelSelect, $setup.state.domain]
                      ])
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    type: "button",
                    class: "email_chk_btn",
                    onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => ($setup.existEmail && $setup.existEmail(...args)))
                  }, "중복확인")
                ])
              ]),
              ($setup.check.existEmail)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    class: _normalizeClass(["verf_txt", $setup.check.exist ? 'fail' : 'success']),
                    style: {"display":"block"}
                  }, _toDisplayString($setup.state.excistText), 3))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("div", _hoisted_24, [
                  _withDirectives(_createElementVNode("input", {
                    type: "tel",
                    onInput: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => ($setup.phonePaternCheck && $setup.phonePaternCheck(...args))),
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.state.phone) = $event)),
                    placeholder: "전화번호"
                  }, null, 544), [
                    [_vModelText, $setup.state.phone]
                  ]),
                  _hoisted_25
                ])
              ]),
              ($setup.check.phone)
                ? (_openBlock(), _createElementBlock("p", _hoisted_26, " 전화번호가 정확한지 확인해 주세요. "))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("button", {
              id: "submit_btn",
              onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => ($setup.checkForm && $setup.checkForm(...args)))
            }, [
              _hoisted_27,
              _createTextVNode("회원가입 ")
            ]),
            _hoisted_28
          ])
        ])
      ])
    ]),
    _createVNode(_component_ModalComponent, {
      show: $setup.state.isModalOpen,
      yes: $setup.modal.confirm,
      no: $setup.modal.cancel,
      content: $setup.modal.content,
      onClose: $setup.modalClose
    }, null, 8, ["show", "yes", "no", "content", "onClose"])
  ], 64))
}